import Hero from "../components/Hero";
import Services from "../components/Services";
import Tiers from "../components/Tiers";
import Gallery from "../components/Gallery";
import About from "../components/About";
import Process from "../components/Process";
import ServiceArea from "../components/ServiceArea";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import { usePageMeta } from "../hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title:
      "Swift Luxury Walls | Premier Custom Entertainment Creations — Tampa Bay, FL",
    description:
      "Swift Luxury Walls builds custom media walls, accent walls, fireplaces, wood slat installations and built-ins across Tampa, Brandon, Riverview, Land O' Lakes, Clearwater, St. Petersburg, Sarasota and Bradenton. Call 813-449-1138.",
    canonicalPath: "/",
  });

  return (
    <>
      <Hero />
      <Services />
      <Tiers />
      <Gallery />
      <About />
      <Process />
      <ServiceArea />
      <Testimonials />
      <Contact />
    </>
  );
}
